import React from 'react';
import FileDropZone from './FileDropZone';

/**
 * ProofUploadField — thin wrapper over the shared FileDropZone (compact 'button'
 * variant), kept as a stable public API for existing consumers (e.g. MatchDialog).
 * Stages the chosen/dropped File(s) to the parent via onFileChange / onFilesChange;
 * the parent uploads.
 *
 * T3-129: supports MULTIPLE proofs. Pass `multiple` with `files` / `onFilesChange` /
 * `onRemoveAt`; the single-file props are unchanged for existing callers. As with
 * FileDropZone, `onFilesChange` receives only the NEWLY PICKED BATCH — the parent
 * accumulates (and dedupes).
 */
const ProofUploadField = ({
  file,
  onFileChange,
  multiple = false,
  files,
  onFilesChange,
  onRemoveAt,
  label = 'Proof of Document',
  helperText,
  disabled = false,
  error,
}) => (
  <FileDropZone
    variant="button"
    multiple={multiple}
    file={file}
    onFile={onFileChange}
    files={files}
    onFiles={onFilesChange}
    onRemoveAt={onRemoveAt}
    accept="application/pdf,image/*"
    label={label}
    helperText={helperText}
    disabled={disabled}
    error={error}
  />
);

export default ProofUploadField;
